export const THEME_LIST = [
    { name: "yellow", color: "rgb(253, 183, 22)", checked: false },
    { name: "olive", color: "rgb(198, 217, 47)", checked: false },
    { name: "green", color: "#42C9A1", checked: true },
    { name: "lime", color: "rgb(8, 255, 25)", checked: false },
    { name: "blue", color: "rgb(52, 134, 199)", checked: false },
    { name: "teal", color: "rgb(129, 209, 224)", checked: false }
];